import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import './scss/style.scss';
import Amplify from 'aws-amplify';
import awsconfig from './awsconfigExport';
import { Auth } from 'aws-amplify';
import '@fontsource/noto-sans-jp';

Amplify.configure(awsconfig);

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('./component/pages/Login'));
const FirstLogin = React.lazy(() => import('./component/pages/FirstLogin'));
const PasswordReset = React.lazy(() => import('./component/pages/PasswordReset'));
const PasswordResetVerification = React.lazy(() => import('./component/pages/PasswordResetVerification'));
const Logout = React.lazy(() => import('./views/pages/logout/Logout'));
const PasswordChange = React.lazy(() => import('./component/pages/PasswordChange'));

class App extends Component {
  // mod@ccs start ---
  state = {
    isAuthenticated: false,
    isAuthenticating: true,
    user: null,
  };

  setAuthStatus = (authenticated) => {
    this.setState({ isAuthenticated: authenticated });
  };

  setUser = (user) => {
    this.setState({ user: user });
  };

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  async componentDidMount() {
    try {
      await Auth.currentSession();
      this.setAuthStatus(true);

      const user = await Auth.currentAuthenticatedUser();
      this.setUser(user);
    } catch (error) {
      console.log(error);
    }

    this.setState({ isAuthenticating: false });
  }
  //mod@ccs end ---

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  render() {
    // mod@ccs ---
    const authProps = {
      isAuthenticated: this.state.isAuthenticated,
      user: this.state.user,
      setAuthStatus: this.setAuthStatus,
      setUser: this.setUser,
    };
    // mod@ccs ---

    return (
      // mod@ccs start ---
      !this.state.isAuthenticating && (
        // mod@ccs end ---
        <HashRouter>
          <React.Suspense fallback={loading}>
            <Switch>
              <Route
                exact
                path="/login"
                name="Login Page"
                render={(props) => (!this.state.isAuthenticated ? <Login {...props} auth={authProps} /> : <TheLayout {...props} auth={authProps} />)}
              />
              <Route
                exact
                path="/firstLogin"
                name="FirstLogin Page"
                render={(props) =>
                  !this.state.isAuthenticated ? <FirstLogin {...props} auth={authProps} /> : <TheLayout {...props} auth={authProps} />
                }
              />
              <Route
                exact
                path="/passwordReset"
                name="PasswordReset Page"
                render={(props) =>
                  !this.state.isAuthenticated ? <PasswordReset {...props} auth={authProps} /> : <TheLayout {...props} auth={authProps} />
                }
              />
              <Route
                exact
                path="/passwordResetVerification"
                name="PasswordResetVerification Page"
                render={(props) =>
                  !this.state.isAuthenticated ? <PasswordResetVerification {...props} auth={authProps} /> : <TheLayout {...props} auth={authProps} />
                }
              />
              <Route
                exact
                path="/passwordChange"
                name="PasswordChange Page"
                render={(props) =>
                  this.state.isAuthenticated ? <PasswordChange {...props} auth={authProps} /> : <TheLayout {...props} auth={authProps} />
                }
              />
              <Route
                exact
                path="/logout"
                name="Logout Page"
                render={(props) => (this.state.isAuthenticated ? <Logout {...props} auth={authProps} /> : <TheLayout {...props} auth={authProps} />)}
              />
              <Route path="/" name="Home" render={(props) => <TheLayout {...props} auth={authProps} />} />
            </Switch>
          </React.Suspense>
        </HashRouter>
      )
    );
  }
}

export default App;
